<template>
  <div>
    <BaseLayout @click-back="back" :title="$t('ApexMenu')" hasHeaderBar="true">
      <div class="input-group">
        <div class="input-group-prepend">
          <label class="input-group-text" for="inputGroupSelect01">
            <i class="fas fa-building"></i>
          </label>
        </div>
        <select name id class="form-control" v-model="$store.state.companyId">
          <option
            v-for="c in $store.state.companyList"
            v-bind:key="c.CompanyID"
            :value="c.CompanyID"
          >{{c.CompanyAbbreviation}}</option>
        </select>
      </div>
      <transition-group name="list" tag="p">
        <div
          v-for="(m, index) in $store.state.menu"
          v-bind:key="m.childFunctionId"
          class="menu-icon list-item"
          :style="{background:color[index%color.length]}"
        >
          <div style="width:100%; height:100%" @click="selectItem(m)">
            <div
              style="width:50%; height:50%; color: #fff;margin-top:5%;"
              :class="(m.AppIcon ||'fa fa-sign-in-alt')"
            ></div>
            <br />
            <b style="color:#FFF;">{{m.functionName}}</b>
          </div>
          <!-- <div v-if="m.selected">
            <SubMenu
              :menu="m.childNode"
              :title="m.functionName"
              @childClose="childClose(m)"
              :parentList="[].concat(m)"
              :functionPath="[].concat('MENU',m.functionName)"
            ></SubMenu>
          </div>-->
        </div>
      </transition-group>
    </BaseLayout>
  </div>
</template> 
<script>
import { mapMutations, mapState, mapActions } from "vuex";
// import SubMenu from "@/components/SubMenu.vue";
// import BaseLayout from "@/components/base/BaseLayout.vue";
// import StoreInfo from "@/components/base/StoreInfo.js";

export default {
  // mixins: [StoreInfo],
  name: "MainMenu",
  data: function() {
    return {
      color: [
        "#74b9ff",
        "#00b894",
        "#00cec9",
        "#0984e3",
        "#fab1a0",
        "#ff7675",
        "#fd79a8",
        "#e17055",
        "#636e72",
        "#b2bec3"
      ]
    };
  },
  components: {
    // BaseLayout: BaseLayout,
    // SubMenu: SubMenu
  },
  computed: {
    companyIdUpdate() {
      return this.$store.state.companyId;
    },
    noSelectedFunction: function() {
      return !this.$store.state.menu.some(x => x.selected);
    },
    ...mapState(["companyId", "language", "showRight", "menu"])
  },
  watch: {
    companyIdUpdate: function() {
      this.refreshMenu();
    }
  },
  methods: {
    gohome: function() {
      this.$router.push("/menu");
      this.setShowRight(false);
    },
    logout: function() {
      window.localStorage["apextoken"] = "";
      this.$router.push("/");
      this.setShowRight(false);
    },
    childClose: function(m) {
      // console.log("parent");
      // debugger;
      m.selected = false;
      // this.$forceUpdate();
    },
    back: function() {
      // alert("back");
      this.$router.push("/menu");
    },
    // ...mapMutations([
    //   "setMessageText",
    //   "clearMessageText",
    //   "startLoad",
    //   "endLoad",
    //   "setCompanyList",
    //   "setUserId",
    //   "setMenu",
    //   "setShowRight",
    //   "setCompanyId"
    // ]),
    // ...mapActions(["refreshMenu"]),
    selectItem: function(m) {
      if (m.childNode && m.childNode.length) {
        var fId = m.childFunctionId;
        this.$router.push("/submenu/" + fId);
      } else {
        // alert("set msg");
        // this.$router.push(m.url);
        let resolved = this.$router.resolve(m.url);
        if (resolved.route.name == "Error") {
          this.setMessageText("Requested page not found!");
        } else {
          this.setCurrentFunctionName(m.functionName);
          this.setCurrentFunctionId(m.childFunctionId);
          this.$router.push(m.url);
          // this.$router.replace(m.url);
        }
        // if (m.url) {
        //   this.$router.push(m.url);
        // } else this.setMessageText("No function");
      }

      // m.selected = true;
    }
  },
  mounted: function() {
    if (this.$route.query.deviceId) {
      localStorage.deviceId = this.$route.query.deviceId;
    }
    // if (localStorage.deviceId) {
    //   alert(localStorage.deviceId);
    // }
    // this.setMessageText(localStorage.deviceId);
    // alert("test");
    // alert(1);
    let _this = this;
    // debugger;
    if (localStorage.apextoken && !_this.$store.state.userName) {
      this.$http.post("/WebApp/Authenticate/ContinuousLogin", {});
      // alert(_this.$store.state.userId);
      var loginData = {
        os: this.$route.query.os
      };
      _this.startLoad();

      //現階段有token表示可登入
      this.$http
        .post("/WebApp/Information/GetInformation", {
          language: window.localStorage["apexlanguage"]
        })

        .then(res => {
          _this.isServerMaintenance = false;
          if (res.data.LoginResult) {
            window.localStorage["apextoken"] = res.data.Token;
            _this.setCompanyList(res.data.Information.CompanyList);
            _this.setMenu(res.data.Information.Menu);
            if (res.data.Information.UserName) {
              _this.setCompanyId(res.data.Information.CompanyId);
            } else {
              _this.setCompanyId("APPLE");
            }

            // _this.setUserId(_this.userId);
            _this.setLanguage(
              window.localStorage["apexlanguage"] ||
                res.data.Information.Language
            );

            _this.$i18n.locale =
              window.localStorage["apexlanguage"] ||
              res.data.Information.Language;
            _this.setLanguageList(res.data.Information.LanguageList);
            _this.setUserName(res.data.Information.UserName);
            _this.loginSuccess();
            //this.$router.push("/menu");
          } else {
            window.localStorage["apextoken"] = "";
            _this.showPage = true;
            _this.setMessageText("Login failed");
            this.$router.push("/login");
          }
          _this.endLoad();
        })
        .catch(err => {
          _this.isServerMaintenance = true;
          // window.localStorage["apextoken"] = "";
          // this.$router.push("/menu");
          // _this.setMessageText(
          //   "The server is abnormal. Please try again later."
          // );
          _this.showPage = false;
          _this.endLoad();
        });
    } else {
      if (!localStorage.apextoken) this.$router.push("/login");
    }
  }
};
</script>

<style  scoped>
.menu-icon {
  position: relative;
  float: left;
  height: 10em;
  width: 31%;
  margin: 1%;
  border-radius: 1em;
  background: #f05837;
  /* display: inline-block; */
  /* box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19); */
}

.fa {
  width: 50%;
  height: 50%;
}
.navbar-fixed-top {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
}
.list-item {
  display: inline-block;
  /* margin-right: 10px; */
}
.list-enter-active {
  transition: all 1.3s;
}
.list-leave-active {
  /* transition: all 0.3s; */
}
.list-enter/*, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  /* transform: translateX(30px); */
}
.list-leave-to {
  display: none;
  opacity: 0;
}
</style>